import { render, staticRenderFns } from "./platinfoca.vue?vue&type=template&id=07c7ca2a&"
import script from "./platinfoca.vue?vue&type=script&lang=js&"
export * from "./platinfoca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports